<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <!-- page Title -->
      <i-card-vertical headerTitle="위험성평가 작성" device="web">
        <template v-slot:body>
          <v-sheet class="tab-layout">
            <!-- 좌측 tab -->
            <v-sheet class="tab-left">
              <v-select
                :value="searchRiskAssessment"
                :menu-props="{ offsetY: true }"
                :items="riskAssessmentList"
                item-text="riskAssessmentNm"
                item-value="assessmentKey"
                class="search-select editor_bg"
                placeholder="위험성평가명"
                solo
                @change="handleSelectChange"
              ></v-select>
              <v-card color="inner_card_bg" class="overflow-y-auto">
                <v-list v-if="tabList" class="pa-0 contents-menu">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, index) in tabList"
                      :key="item.index"
                      @click="handleTabClick(index)"
                      :class="{ active: selectedKey === index }"
                    >
                      <v-list-item-content>
                        {{ item.processNm }}
                        <v-tooltip top color="primary" max-width="300px">
                          <template v-slot:activator="{ on }">
                            <span class="sub-text">
                              <span>
                                유해위험요인 등록 필요 : {{ item.uncount }}
                                <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                              </span>
                            </span>
                          </template>
                          <div class="tooltip-text">{{ '등록된 유해위험요인이 없는 작업 수' }}</div>
                        </v-tooltip>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-sheet>

            <!-- 우측 테이블 영역 -->
            <!-- table -->
            <v-card
              class="overflow-y-auto"
              :class="breakpoint === 'md' || breakpoint === 'sm' || breakpoint === 'xs' ? 'mt-5' : ''"
            >
              <div v-show="selectedKey === selectedKey">
                <creationPanelTree
                  class="custom-panel"
                  ref="creationPanelTree"
                  :tabList="tabList[selectedKey]"
                  :datasource="datasource"
                  :dataSetList="dataSetList"
                  :searchProcess="panel ? panel : 0"
                  @titleClick="titleClick"
                />
                <!-- 거푸집 작업 tab -->
              </div>
            </v-card>
          </v-sheet>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer
            v-model="procedureShow"
            width="75%"
            absolute
            right
            temporary
            class="feedback-area"
          >
            <ProcedureComponent :type="'00002'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right :useBtnList="buttonUseList" @btnSearch="btnSearch()" @btnSave="btnSave"></i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              color="btn_text"
              :text="'개설 이동'"
              :icon="'back'"
              @click="btnOpen"
              :appendDivider="true"
            ></i-icon-button>
            <i-icon-button
              color="btn_text"
              :text="'감소대책 이동'"
              :icon="'forward'"
              @click="btnReduction"
            ></i-icon-button>
          </template>
        </i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              color="btn_text"
              :text="'절차서'"
              :icon="'file'"
              @click="procedureShow = !procedureShow"
            ></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>
<script>
import notify from 'devextreme/ui/notify'
import { AesDecrypt } from '@/utils/aes256'
// utils
import { getPreMonth, getCurrentDate } from '@/utils/common.js'

import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import creationPanelTree from './components/CreationPanelTree'
//위험성평가명
import { getRiskAssessments } from '@/api/riskAssessment/riskAssessmentProcess.js'
// 위험성평가 기본 값
import { getConfirmationRegulations } from '@/api/riskAssessment/implementationRegulations.js'
//위험성평가 작업내용
import {
  getRiskAssessmentCreationList,
  getRiskAssessmentCreation,
  saveRiskAssessmentCreation,
  getRptRiskAssessmentCreation
} from '@/api/riskAssessment/riskAssessmentCreation.js'
import { getCommonCode } from '@/api/common/commonApi'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    creationPanelTree,
    // 절차서 컴포넌트
    ProcedureComponent
  },

  data() {
    return {
      param: {},
      initCompId: '',
      buttonUseList: [
        'btnSearch', //조회
        'btnSave'
      ],
      selectedKey: 0,
      searchProcess: '',
      tabList: [],
      riskAssessmentList: [],
      searchRiskAssessment: '',
      searchKey: '',
      test: '',
      routeData: '',
      datasource: [],
      detailList: [],
      //파라미터
      panelData: '',
      //선택된 패널 index
      panel: '',
      // 넘겨줄데이터
      dataSetList: [
        {
          riskFactorList: [],
          victimList: [],
          riskEstimation: '00001',
          riskEstimationList: [],
          riskEstimationSetting: [],
          riskEstimationValue: [],
          infoBtnList: [],
          freqValueList: [],
          freqList: [],
          strengthList: [],
          deleteList: [],
          riskInit: {}
        }
      ],
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false // 절차서 보이기
    }
  },
  watch: {},
  created() {
    // 초기 페이지 진입 시 compId 세팅
    this.initCompId = this.getCompId()
  },
  mounted() {
    let param = {
      clntId: this.getClntId(),
      compId: this.initCompId
    }
    this.setComboBox(param)
  },
  activated() {
    // 페이지 이동시
    // 추가, 다른 데이터 상세 정보 호출 시
    if (this.$route.params.data) {
      //초기화
      this.selectedKey = 0
      this.panel = 0
      //추가
      if (!this.$route.params.data.__created__) {
        // 페이지 이동 시, 다른 페이지에서 상세정보 조회 시
        let param = this.$route.params.data
        this.setComboBox(param)
      }
    }
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      // 데이터 공간 초기화
      this.param = ''
      this.tabList = []
      this.datasource = []
      this.initCompId = this.getCompId()
      let param = {
        clntId: this.getClntId(),
        compId: this.initCompId
      }
      this.setComboBox(param)
    }
  },
  beforeMount() {
    Promise.all([
      getCommonCode('RA004') /*위험분류 */,
      getCommonCode('RA005') /*위험성평가 사고발생시 피해예상자 */,
      getCommonCode('RA002') /*위험성 추정*/,
      getCommonCode('RA002_1'),
      getCommonCode('RA002_2'),
      getCommonCode('RA002_3')
    ])
      .then(response => {
        this.dataSetList[0].riskFactorList = response[0].list
        this.dataSetList[0].victimList = response[1].list
        this.dataSetList[0].riskEstimationList = response[2].list
        // this.dataSetList[0].riskEstimation = response[2].list[0].minorCd
        this.dataSetList[0].riskEstimationList.forEach(el => {
          this.dataSetList[0].riskEstimationSetting[el.minorCd] = { minorNm: el.minorNm, minorCd: el.minorCd, data: [] }
        })
        this.dataSetList[0].riskEstimationValue = response[3].list
        response[3].list.forEach(el => {
          if (this.dataSetList[0].riskEstimationSetting[el.extra1]?.data) {
            this.dataSetList[0].riskEstimationSetting[el.extra1].data.push({ minorNm: el.minorNm, minorCd: el.minorCd, extra: el.extra2 })
          }
        })
        this.dataSetList[0].infoBtnList = response[4].list

        this.dataSetList[0].freqValueList = response[5].list
      })
      .finally(() => {
        if (Object.keys(this.dataSetList[0].riskEstimationSetting).length > 0) {
          this.dataSetList[0].freqList = this.dataSetList[0].riskEstimationSetting['00001'].data
            .filter(el => el.extra == 'frequency')
            .sort((a, b) => a.minorNm.localeCompare(b.minorNm))
          this.dataSetList[0].strengthList = this.dataSetList[0].riskEstimationSetting['00001'].data
            .filter(el => el.extra == 'strength')
            .sort((a, b) => a.minorNm.localeCompare(b.minorNm))
        }
      })
  },

  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name
    }
  },
  methods: {
    setComboBox(param) {
      console.log('1.setComboBox param', param)
      // 위험성 평가명 조회
      Promise.all([getRiskAssessments(param, false)]).then(response => {
        this.riskAssessmentList = response[0].list
        if (this.riskAssessmentList) {
          if (param.__created__ == false) {
            this.searchRiskAssessment = param.clntId + '_' + param.compId + '_' + param.writeDt + '_' + param.docNo
            this.param = {
              clntId: param.clntId,
              compId: param.compId,
              writeDt: param.writeDt,
              docNo: param.docNo,
              constructId: param.constructId,
              processId: param.processId
            }
          } else {
            if (this.riskAssessmentList[0]) {
              this.searchRiskAssessment = this.riskAssessmentList[0].assessmentKey
              const [clntId, compId, writeDt, docNo] = this.searchRiskAssessment.split('_')
              this.param = {
                clntId: clntId,
                compId: compId,
                writeDt: writeDt,
                docNo: docNo
              }
            }
          }
          this.btnSearch(true)
        }
      })
    },
    async btnSearch(isNotify) {
      //process 조회
      this.openLoading('searching')
      getRiskAssessmentCreationList(this.param, isNotify)
        .then(response => {
          if (response.success) {
            response.list.forEach(item => {
              item.uncount = item.works.filter(work => work.factor.length === 0).length
            })
            this.tabList = response.list
          }
        })
        .finally(() => {
          this.endLoading()
          this.searchPanelData()
          this.riskTypeSetting()
        })
    },
    riskTypeSetting() {
      // 개설에서 빈도강도 or 수준3단계 default 값 가져오기
      this.dataSetList[0].riskInit = this.riskAssessmentList.find(el => el.assessmentKey === this.searchRiskAssessment)
      if (this.dataSetList[0].riskInit) {
        let riskType = this.dataSetList[0].riskEstimationValue.find(el => el.minorCd == this.dataSetList[0].riskInit.riskEstimationVal1)
        if (riskType) {
          this.dataSetList[0].riskEstimation = riskType.extra1
        }
      }
    },
    async searchPanelData(index) {
      if (!this.selectedKey && this.$route.params.data) {
        // 필터링된 요소의 인덱스 배열
        this.tabList.forEach((tab, index) => {
          if (tab.processId === this.param.processId) {
            this.selectedKey = index
            return // 원하는 요소를 찾았으니 루프 종료
          }
        })
      }
      if (!this.selectedKey) {
        //선택된 패널이 없으면 첫번째 데이터 조회
        index = 0
      } else index = this.selectedKey

      if (this.tabList[index]) {
        let param = {
          clntId: this.getClntId(),
          compId: this.initCompId,
          writeDt: this.tabList[index].writeDt,
          docNo: this.tabList[index].docNo,
          constructId: this.tabList[index].constructId,
          processId: this.tabList[index].processId
        }

        // 세부 process 조회
        await getRiskAssessmentCreation(param, true)
          .then(response => {
            if (response.success) {
              this.detailList = response.list
            }
          })
          .finally(() => {
            const groupedData = {}
            this.detailList.forEach(item => {
              if (!groupedData[item.workId]) {
                groupedData[item.workId] = 0
              }
              groupedData[item.workId]++
            })
            // 공정별 위험요인 수 cnt에 할당
            this.tabList[index].works.forEach(item => {
              item.cnt = groupedData[item.workId] || 0
            })
            // datasource 할당
            this.riskValueSetting(index)
            this.datasource = this.tabList[index].works
            if (!this.panel) {
              //선택된 패널 없으면
              let panelIdx = 0
              this.titleClick(panelIdx)
            } else this.titleClick(this.panel)
          })
      }
    },
    riskValueSetting(index) {
      //위험성 수준 값이 없을 때 초기 값 개설에서 가져와서 보여주기
      this.tabList[index].works.forEach(item => {
        item.factor.forEach(el => {
          if (!el.riskEstimationVal1) {
            el.riskEstimationVal1 = this.dataSetList[0].riskInit.riskEstimationVal1
            if (this.dataSetList[0].riskEstimation == '00001') {
              //빈도강도법일때는 Num 과 val2도 넣어주기
              el.riskEstimationVal2 = this.dataSetList[0].riskInit.riskEstimationVal2
            }
          }
        })
      })
    },
    handleSelectChange(value) {
      console.log('2 handleSelectChange', value)
      this.panel = ''
      this.selectedKey = 0
      this.searchKey = value
      this.searchRiskAssessment = this.searchKey
      const [clntId, compId, writeDt, docNo] = this.searchRiskAssessment.split('_')
      this.datasource = []

      this.param = {
        clntId: clntId,
        compId: compId,
        writeDt: writeDt,
        docNo: docNo
      }
      this.btnSearch(true)
    },

    handleTabClick(index) {
      if (this.selectedKey !== index) {
        let saveData = this.$refs.creationPanelTree.datasource.filter(el => el.__created__ || el.__updated__)
        if (saveData.length === 0) {
          this.panel = ''
          this.selectedKey = index
          console.log('3 handleTabClick')
          this.datasource = this.tabList[index].works
          this.btnSearch(true)
          this.searchPanelData()
        } else {
          this.vToastifySavePrompt(
            this.$t(`작성중인 데이터를 저장하시겠습니까?`),
            'info',
            async current => {
              this.btnSave(true)
              this.panel = ''
              this.selectedKey = index
              this.datasource = this.tabList[index].works
              this.btnSearch(true)
              this.searchPanelData()
            },
            async current => {
              this.panel = ''
              this.selectedKey = index
              this.datasource = this.tabList[index].works
              this.btnSearch(true)
              this.searchPanelData()
            }
          )
        }
      }
    },

    //패널 title 클릭 이벤트
    titleClick(index) {
      //선택된 패널 저장
      this.panel = index
      this.panelData = this.datasource[index]
    },
    btnSave(toRouter = null) {
      // 모든 요소가 조건을 충족하는지 확인하는 플래그
      let hasMissingFactors = false
      let failData = ''
      // 데이터 바인딩된 배열을 순회하며 확인
      this.datasource.forEach((el, elIndex) => {
        el.factor.forEach((item, itemIndex) => {
          if (!item.riskFactorDiv || !item.riskFactorContent || !item.riskEstimationVal1) {
            hasMissingFactors = true
            failData = this.datasource[elIndex].workNm
            // console.log('저장입력확인 - 요소:', item, '인덱스:', elIndex, '-', itemIndex, this.datasource[elIndex].workNm)
          }
        })
      })
      // 필수 입력 요소가 누락된 경우 경고 표시
      if (hasMissingFactors) {
        this.vToastify(this.$t(`[${failData}]<br/>저장 입력 항목을 확인해주세요.`), 'info')
        return
      }

      if (toRouter === null) {
        // 라우터 이동 저장이 아닐 경우
        this.vToastifyPrompt(
          this.$t('저장하시겠습니까?'),
          'info',
          async current => {
            this.openLoading()

            // 최초 저장 시 insert 처리
            let saveData = []
            this.datasource.forEach(item => {
              item.factor.forEach(el => {
                if (el.__created__ || el.__updated__) saveData.push(el)
              })
            })
            if (this.dataSetList[0].deleteList.length > 0) {
              console.log('삭제', this.dataSetList[0].deleteList)
              saveData.push(...this.dataSetList[0].deleteList)
            }
            console.log('저장 saveData', saveData)
            saveRiskAssessmentCreation(saveData, true)
              .then(response => {
                this.datasource.forEach(item => {
                  item.factor.forEach(el => {
                    el.__created__ = false
                    el.__updated__ = false
                  })
                })
                this.btnSearch(true)
                this.searchPanelData(this.selectedKey)
              })
              .finally(res => {
                this.endLoading()
              })
          },
          null,
          true
        )
      } else {
        // 라우터 이동 저장일 경우
        this.openLoading()

        // 최초 저장 시 insert 처리
        let saveData = []
        this.datasource.forEach(item => {
          item.factor.forEach(el => {
            if (el.__created__ || el.__updated__) saveData.push(el)
          })
        })
        if (this.dataSetList[0].deleteList.length > 0) {
          console.log('삭제', this.dataSetList[0].deleteList)
          saveData.push(...this.dataSetList[0].deleteList)
        }
        console.log('저장 saveData', saveData)
        saveRiskAssessmentCreation(saveData, true)
          .then(response => {
            this.datasource.forEach(item => {
              item.factor.forEach(el => {
                el.__created__ = false
                el.__updated__ = false
              })
            })
            this.btnSearch(true)
            this.searchPanelData(this.selectedKey)
          })
          .finally(res => {
            this.endLoading()
            if (typeof toRouter === 'object') this.$router.push(toRouter)
          })
      }
    },

    btnOpen() {
      if (!this.searchRiskAssessment) {
        this.vSnackbar(this.$t('위험성평가를 선택해주세요.'), 'warning')
        return
      }
      let saveData = this.$refs.creationPanelTree.datasource.filter(el => el.__created__ || el.__updated__)
      const toRouter = {
        name: 'RiskAssessmentManageDetail',
        params: {
          data: {
            clntId: this.param.clntId,
            compId: this.param.compId,
            writeDt: this.param.writeDt,
            docNo: this.param.docNo,
            constructId: this.param.constructId,
            processId: this.param.processId,
            __created__: false
          }
        }
      }
      if (saveData.length === 0) {
        this.vToastifyPrompt(this.$t(`위험성평가 개설 페이지로 이동하시겠습니까?`), 'info', async current => {
          this.$router.push(toRouter)
        })
      } else {
        this.vToastifySavePrompt(
          this.$t('작성중인 데이터를 저장하고<br/> 위험성평가 개설 페이지로 이동하시겠습니까?'),
          'info',
          async current => {
            this.btnSave(toRouter)
          },
          async current => {
            this.$router.push(toRouter)
          }
        )
      }
    },
    btnReduction() {
      if (!this.panelData.workId) {
        this.vSnackbar(this.$t('선택된 공정이 없습니다.'), 'warning')
        return
      }
      let saveData = this.$refs.creationPanelTree.datasource.filter(el => el.__created__ || el.__updated__)
      const toRouter = {
        name: 'RiskAssessmentMeasuresReduction',
        params: {
          data: {
            clntId: this.param.clntId,
            compId: this.param.compId,
            writeDt: this.param.writeDt,
            docNo: this.param.docNo,
            constructId: this.panelData.constructId,
            processId: this.panelData.processId,
            __created__: false
          },
          searchRiskAssessment: this.searchRiskAssessment,
          selectedKey: this.selectedKey,
          panel: this.panel
        }
      }
      if (saveData.length === 0) {
        this.vToastifyPrompt(this.$t(`[${this.panelData.workNm}]<br/>위험성평가 감소대책 페이지로 이동하시겠습니까?`), 'info', async current => {
          this.$router.push(toRouter)
        })
      } else {
        this.vToastifySavePrompt(
          this.$t(`작성중인 데이터를 저장하고<br/> [${this.panelData.workNm}]<br/>위험성평가 감소대책 페이지로 이동하시겠습니까?`),
          'info',
          async current => {
            this.btnSave(toRouter)
          },
          async current => {
            this.$router.push(toRouter)
          }
        )
      }
    },
    ///////////////////////////////////////
    /*               Event               */
    ///////////////////////////////////////
    formatDate(date) {
      if (!date) return null

      if (date.indexOf('-') == -1) {
        const year = date.substring(0, 4)
        const month = date.substring(4, 6)
        const day = date.substring(6, 8)
        return `${year}-${month}-${day}`
      } else if (date.indexOf('-') > -1) {
        const [year, month, day] = date.split('-')
        return `${year}.${month}.${day}`
      } else {
        return date
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
